import lang from '../../lib/language';

import WarningIcon from '../../assets/img/warning-icon.svg';

import styles from './RewindTradingDayNotification.module.scss';

const RewindTradingDayNotification = () => (
  <div className={styles.container} id="rewindTradingDayNotification">
    <div className={styles.content}>
      <img className={styles.warningIcon} src={WarningIcon} alt="Warning" />
      <div>{lang.rewindingTradingDay()}</div>
    </div>
  </div>
);

export default RewindTradingDayNotification;
